/** Public Supabase Functions URL for FAL queue webhooks (no secret — token is added server-side). */
export function getPublicFalQueueWebhookFunctionUrl(): string {
  const base = (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.replace(/\/$/, '') || '';
  if (!base) return '';
  return `${base}/functions/v1/fal-queue-webhook`;
}
